import { useOnPressButtons } from '../../hooks/useOnPressButtons'
import { useSelectReportData } from '../../hooks/useSelectReportData'
import '../../Report.css'
import GoalItem from '../GoalListItem/GoalItem'
import './Page5-goals.css'

import page3bg from '../../assets/page-dark-bg.png'

const Page5 = () => {
  const { goalsItems, isNoGoals, isSalesPart } = useSelectReportData()
  const { handlePressButtonIndex } = useOnPressButtons()

  if (!isSalesPart) {
    return null
  }

  if (isNoGoals) {
    return null
  }
  //

  return (
    <div
      className={'bg-image-config'}
      style={{
        position: 'relative',
        backgroundImage: `url(${page3bg})`,
      }}
    >
      <div style={{ padding: '40px 15px 50px 15px' }}>
        <p
          className={'title-bold inverted-text'}
          style={{ fontSize: '1.2rem' }}
        >
          Change is hard -
          <span
            style={{ fontWeight: '700' }}
            className={'rainbow-text'}
          >
            {' '}
            we can help!
          </span>
        </p>
        <p className={'text-on-dark'}>
          We understand that everyone is different and that's why our continued care program is designed around your assessment in order to give you the best possible plan for your unique needs.
        </p>
        <p className={'text-on-dark'}>With our program, you will receive immediate feedback on your progress, which will help you stay motivated and on track to achieving your desired outcome.</p>
        <p className={'text-on-dark'}>Your Plan will be focused on achieving the following measurable results:</p>
        {goalsItems.map((directionItem, key) => {
          return (
            <GoalItem
              dark={true}
              {...directionItem}
              key={key}
            />
          )
        })}
        <button
          onClick={handlePressButtonIndex(2)}
          className={'button-rainbow'}
          style={{ marginTop: 20 }}
        >
          Start Continued Care Now
        </button>
      </div>
    </div>
  )
}

export default Page5
